import { render, staticRenderFns } from "./OrganizationBiaodi.vue?vue&type=template&id=260c8528&"
import script from "./OrganizationBiaodi.vue?vue&type=script&lang=js&"
export * from "./OrganizationBiaodi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports